module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": "",
      "content-class": "ims-standard-dialog"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card"
  }, [_c('v-card-title', {
    staticClass: "title ims-modal-header"
  }, [_c('span', [_vm._v("Change Campaign Settings")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "secondary",
      "aria-label": "Close",
      "title": "Close"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), (_vm.campaignData) ? _c('v-card-text', {
    staticClass: "body-2 ims-modal-body campaign-settings-body"
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "label": "Campaign",
      "disabled": ""
    },
    model: {
      value: (_vm.campaignData.name),
      callback: function($$v) {
        _vm.$set(_vm.campaignData, "name", $$v)
      },
      expression: "campaignData.name"
    }
  }), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "fixed-tabs": ""
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('v-tab', {
    attrs: {
      "href": "#tab-brief"
    }
  }, [_vm._v("Campaign Brief")]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "href": "#tab-report"
    }
  }, [_vm._v("Report")]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "href": "#tab-permissions"
    }
  }, [_vm._v("Permissions")])], 1), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('v-tab-item', {
    attrs: {
      "value": "tab-brief"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-switch', {
    attrs: {
      "label": "Show Budget To Client"
    },
    model: {
      value: (_vm.submittingData.settings.showBudgetToClient),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "showBudgetToClient", $$v)
      },
      expression: "submittingData.settings.showBudgetToClient"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Enable Video Brief"
    },
    model: {
      value: (_vm.submittingData.settings.enableVideoBrief),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enableVideoBrief", $$v)
      },
      expression: "submittingData.settings.enableVideoBrief"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Enable Event Brief"
    },
    model: {
      value: (_vm.submittingData.settings.enableEventBrief),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enableEventBrief", $$v)
      },
      expression: "submittingData.settings.enableEventBrief"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Send Weekly Report"
    },
    model: {
      value: (_vm.submittingData.settings.sendWeeklyReport),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "sendWeeklyReport", $$v)
      },
      expression: "submittingData.settings.sendWeeklyReport"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Auto Update Report"
    },
    model: {
      value: (_vm.submittingData.settings.autoUpdate),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "autoUpdate", $$v)
      },
      expression: "submittingData.settings.autoUpdate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "value": "tab-report"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-row', {
    staticClass: "ma-0 pa-0 mb-3 d-flex align-center justify-space-between"
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "10"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0 pt-0",
    attrs: {
      "label": "Enable Post Analysis",
      "hide-details": ""
    },
    model: {
      value: (_vm.submittingData.settings.enablePostAnalysis),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enablePostAnalysis", $$v)
      },
      expression: "submittingData.settings.enablePostAnalysis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0 text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-1",
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openPostAnalysisColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 2848695215)
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0 mb-3 d-flex align-center justify-space-between"
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "10"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0 pt-0",
    attrs: {
      "label": "Enable LinkedIn Analysis",
      "hide-details": ""
    },
    model: {
      value: (_vm.submittingData.settings.enableLinkedInAnalysis),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enableLinkedInAnalysis", $$v)
      },
      expression: "submittingData.settings.enableLinkedInAnalysis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0 text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-1",
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openLinkedInAnalysisColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 2542830641)
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0 mb-3 d-flex align-center justify-space-between"
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "10"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0 pt-0",
    attrs: {
      "label": "Enable X (Twitter) Analysis",
      "hide-details": ""
    },
    model: {
      value: (_vm.submittingData.settings.enableTwitterAnalysis),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enableTwitterAnalysis", $$v)
      },
      expression: "submittingData.settings.enableTwitterAnalysis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0 text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-btn', {
    staticClass: "ml-1",
    attrs: {
      "icon": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.openTwitterAnalysisColSettingsModal
    }
  }, [_c('i', {
    staticClass: "fas fa-cog fa-lg",
    attrs: {
      "title": "Settings"
    }
  })])], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0 mb-3 d-flex align-center justify-space-between"
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "10"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0 pt-0",
    attrs: {
      "label": "Enable Story Analysis",
      "hide-details": ""
    },
    model: {
      value: (_vm.submittingData.settings.enableStoryAnalysis),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enableStoryAnalysis", $$v)
      },
      expression: "submittingData.settings.enableStoryAnalysis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0 text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-1",
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openStoryAnalysisColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 4291397140)
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0 mb-3 d-flex align-center justify-space-between"
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "10"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0 pt-0",
    attrs: {
      "label": "Enable Reel Analysis",
      "hide-details": ""
    },
    model: {
      value: (_vm.submittingData.settings.enableReelAnalysis),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enableReelAnalysis", $$v)
      },
      expression: "submittingData.settings.enableReelAnalysis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0 text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-1",
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openReelAnalysisColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 3255546921)
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0 mb-3 d-flex align-center justify-space-between"
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "10"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0 pt-0",
    attrs: {
      "label": "Enable Tiktok Analysis",
      "hide-details": ""
    },
    model: {
      value: (_vm.submittingData.settings.enableTikTokAnalysis),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enableTikTokAnalysis", $$v)
      },
      expression: "submittingData.settings.enableTikTokAnalysis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0 text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-1",
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openTikTokAnalysisColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 2261509425)
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0 mb-3 d-flex align-center justify-space-between"
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "10"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0 pt-0",
    attrs: {
      "label": "Enable Youtube Analysis",
      "hide-details": ""
    },
    model: {
      value: (_vm.submittingData.settings.enableYoutubeAnalysis),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enableYoutubeAnalysis", $$v)
      },
      expression: "submittingData.settings.enableYoutubeAnalysis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0 text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-1",
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openYoutubeAnalysisColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 3144399858)
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0 mb-3 d-flex align-center justify-space-between"
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "10"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0 pt-0",
    attrs: {
      "label": "Enable Facebook Analysis",
      "hide-details": ""
    },
    model: {
      value: (_vm.submittingData.settings.enableFbAnalysis),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enableFbAnalysis", $$v)
      },
      expression: "submittingData.settings.enableFbAnalysis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0 text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-1",
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openFbAnalysisColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 4213888595)
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0 mb-3 d-flex align-center justify-space-between"
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "10"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0 pt-0",
    attrs: {
      "label": "Enable XHS Analysis",
      "hide-details": ""
    },
    model: {
      value: (_vm.submittingData.settings.enableXHSAnalysis),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enableXHSAnalysis", $$v)
      },
      expression: "submittingData.settings.enableXHSAnalysis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0 text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-1",
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openXHSAnalysisColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 107774100)
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0 mb-3 d-flex align-center justify-space-between"
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "10"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0 pt-0",
    attrs: {
      "label": "Enable Lemon8 Analysis",
      "hide-details": ""
    },
    model: {
      value: (_vm.submittingData.settings.enableLemonAnalysis),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enableLemonAnalysis", $$v)
      },
      expression: "submittingData.settings.enableLemonAnalysis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0 text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-1",
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openLemonAnalysisColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 226705938)
  })], 1)], 1), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Enable Overall Section"
    },
    model: {
      value: (_vm.submittingData.settings.enableOverallSection),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enableOverallSection", $$v)
      },
      expression: "submittingData.settings.enableOverallSection"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "value": "tab-permissions"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', [_c('v-btn', {
    staticClass: "ims-btn-third",
    on: {
      "click": function($event) {
        return _vm.startAssignCS()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-account-switch")]), _vm._v("\n                    Manage Permissions\n                  ")], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "sm": "12",
      "md": "7"
    }
  }, [_c('v-btn', {
    staticClass: "btn__p100",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.changeCampaignStatus()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "secondary",
      "left": ""
    }
  }, [_vm._v("mdi-arrow-left-right")]), _vm._v(" "), _c('span', {
    staticClass: "secondary--text"
  }, [_vm._v("Change Campaign Status")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": "",
      "open-on-hover": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.copyReportLink()
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-content-copy")]), _vm._v(" "), _c('span', [_vm._v("Copy HTML Report Link")])], 1)]
      }
    }], null, false, 4048819226),
    model: {
      value: (_vm.reportLinkCopied),
      callback: function($$v) {
        _vm.reportLinkCopied = $$v
      },
      expression: "reportLinkCopied"
    }
  }, [_vm._v(" "), _c('span', [_c('v-icon', {
    attrs: {
      "color": "white darken-2"
    }
  }, [_vm._v("mdi-check-all")]), _vm._v(" Copied")], 1)])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": "",
      "open-on-hover": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.copyAIReportLink()
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-content-copy")]), _vm._v(" "), _c('span', [_vm._v("Copy AI Report Link")])], 1)]
      }
    }], null, false, 238529799),
    model: {
      value: (_vm.aiReportLinkCopied),
      callback: function($$v) {
        _vm.aiReportLinkCopied = $$v
      },
      expression: "aiReportLinkCopied"
    }
  }, [_vm._v(" "), _c('span', [_c('v-icon', {
    attrs: {
      "color": "white darken-2"
    }
  }, [_vm._v("mdi-check-all")]), _vm._v(" Copied")], 1)])], 1)], 1), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-reportlink"
    },
    domProps: {
      "value": _vm.reportLink
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-ai-reportlink"
    },
    domProps: {
      "value": _vm.aiReportLink
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "no-gutters"
  }, [_c('v-col', {
    attrs: {
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-btn', {
    class: {
      'btn-change-pass btn__p100': _vm.isCampaignPasscode,
      'btn-change-pass rounded btn__p100': !_vm.isCampaignPasscode,
    },
    attrs: {
      "color": "error"
    },
    on: {
      "click": function($event) {
        return _vm.startReportPasscode()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-lock")]), _vm._v("\n                        Change Passcode\n                      ")], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "md": "6",
      "sm": "12"
    }
  }, [(_vm.isCampaignPasscode) ? _c('v-tooltip', {
    attrs: {
      "top": "",
      "open-on-hover": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "btn-copy-pass btn__p100",
          attrs: {
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.copyReportPasscode()
            }
          }
        }, on), [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-content-copy")]), _vm._v(" "), _c('span', [_vm._v("Copy Passcode")])], 1)]
      }
    }], null, false, 434988839),
    model: {
      value: (_vm.passcodeCopied),
      callback: function($$v) {
        _vm.passcodeCopied = $$v
      },
      expression: "passcodeCopied"
    }
  }, [_vm._v(" "), _c('span', [_c('v-icon', {
    attrs: {
      "color": "white darken-2"
    }
  }, [_vm._v("mdi-check-all")]), _vm._v(" Copied")], 1)]) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-passcode"
    },
    domProps: {
      "value": _vm.campaign.passcode
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.isCopyFeedback) ? _c('FeedbackAccessPanel', {
    attrs: {
      "campaign-id": String(_vm.campaignData.id)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('v-divider'), _vm._v(" "), _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "sm": "12",
      "md": "7"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": "",
      "open-on-hover": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "btn__p100",
          attrs: {
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.copyBrandSheetLink()
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-content-copy")]), _vm._v(" "), _c('span', [_vm._v("Copy Brand Fact Sheet Link")])], 1)]
      }
    }], null, false, 1828213774),
    model: {
      value: (_vm.brandLinkCopied),
      callback: function($$v) {
        _vm.brandLinkCopied = $$v
      },
      expression: "brandLinkCopied"
    }
  }, [_vm._v(" "), _c('span', [_c('v-icon', {
    attrs: {
      "color": "white darken-2"
    }
  }, [_vm._v("mdi-check-all")]), _vm._v(" Copied")], 1)])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm": "12",
      "md": "5"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-brand-link"
    },
    domProps: {
      "value": _vm.brandSheetLink
    }
  })])], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', {
    staticClass: "ims-modal-actions"
  }, [_c('v-btn', {
    attrs: {
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('assign-cs-to-campaign-modal', {
    attrs: {
      "campaign": _vm.campaignDataForCsAssign
    },
    on: {
      "updated": _vm.reload
    },
    model: {
      value: (_vm.assignCsToCampaignDialog),
      callback: function($$v) {
        _vm.assignCsToCampaignDialog = $$v
      },
      expression: "assignCsToCampaignDialog"
    }
  }), _vm._v(" "), _c('report-passcode-modal', {
    attrs: {
      "campaign": _vm.campaignData
    },
    on: {
      "updated": _vm.reload
    },
    model: {
      value: (_vm.reportPasscodeDialog),
      callback: function($$v) {
        _vm.reportPasscodeDialog = $$v
      },
      expression: "reportPasscodeDialog"
    }
  }), _vm._v(" "), _c('change-status-modal', {
    attrs: {
      "campaign": _vm.campaignDataForStatusChange
    },
    on: {
      "updated": _vm.reload
    },
    model: {
      value: (_vm.changeCampaignStatusDialog),
      callback: function($$v) {
        _vm.changeCampaignStatusDialog = $$v
      },
      expression: "changeCampaignStatusDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Post Analysis Columns",
      "items": _vm.postAnalysisTableColsItems,
      "isSort": true
    },
    on: {
      "updated": _vm.updatePostAnalysisStatus
    },
    model: {
      value: (_vm.postAnalysisColSettingsDialog),
      callback: function($$v) {
        _vm.postAnalysisColSettingsDialog = $$v
      },
      expression: "postAnalysisColSettingsDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Story Analysis Columns",
      "items": _vm.storyAnalysisTableColsItems,
      "isSort": true
    },
    on: {
      "updated": _vm.updateStoryAnalysisStatus
    },
    model: {
      value: (_vm.storyAnalysisColSettingsDialog),
      callback: function($$v) {
        _vm.storyAnalysisColSettingsDialog = $$v
      },
      expression: "storyAnalysisColSettingsDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Reel Analysis Columns",
      "items": _vm.reelAnalysisTableColsItems,
      "isSort": true
    },
    on: {
      "updated": _vm.updateReelAnalysisStatus
    },
    model: {
      value: (_vm.reelAnalysisColSettingsDialog),
      callback: function($$v) {
        _vm.reelAnalysisColSettingsDialog = $$v
      },
      expression: "reelAnalysisColSettingsDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Tiktok Analysis Columns",
      "items": _vm.tiktokAnalysisTableColsItems,
      "isSort": true
    },
    on: {
      "updated": _vm.updateTikTokAnalysisStatus
    },
    model: {
      value: (_vm.tiktokAnalysisColSettingsDialog),
      callback: function($$v) {
        _vm.tiktokAnalysisColSettingsDialog = $$v
      },
      expression: "tiktokAnalysisColSettingsDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Youtube Analysis Columns",
      "items": _vm.youtubeAnalysisTableColsItems
    },
    on: {
      "updated": _vm.updateYoutubeAnalysisStatus
    },
    model: {
      value: (_vm.youtubeAnalysisColSettingsDialog),
      callback: function($$v) {
        _vm.youtubeAnalysisColSettingsDialog = $$v
      },
      expression: "youtubeAnalysisColSettingsDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Facebook Analysis Columns",
      "items": _vm.fbAnalysisTableColsItems
    },
    on: {
      "updated": _vm.updateFbAnalysisStatus
    },
    model: {
      value: (_vm.fbAnalysisColSettingsDialog),
      callback: function($$v) {
        _vm.fbAnalysisColSettingsDialog = $$v
      },
      expression: "fbAnalysisColSettingsDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "LinkedIn Analysis Columns",
      "items": _vm.linkedInAnalysisTableColsItems
    },
    on: {
      "updated": _vm.updateLinkedInAnalysisStatus
    },
    model: {
      value: (_vm.linkedInAnalysisColSettingsDialog),
      callback: function($$v) {
        _vm.linkedInAnalysisColSettingsDialog = $$v
      },
      expression: "linkedInAnalysisColSettingsDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "X (Twitter) Analysis Columns",
      "items": _vm.twitterAnalysisTableColsItems
    },
    on: {
      "updated": _vm.updateTwitterAnalysisStatus
    },
    model: {
      value: (_vm.twitterAnalysisColSettingsDialog),
      callback: function($$v) {
        _vm.twitterAnalysisColSettingsDialog = $$v
      },
      expression: "twitterAnalysisColSettingsDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "XHS Analysis Columns",
      "items": _vm.xhsAnalysisTableColsItems
    },
    on: {
      "updated": _vm.updateXHSAnalysisStatus
    },
    model: {
      value: (_vm.xhsAnalysisColSettingsDialog),
      callback: function($$v) {
        _vm.xhsAnalysisColSettingsDialog = $$v
      },
      expression: "xhsAnalysisColSettingsDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Lemon8 Analysis Columns",
      "items": _vm.lemonAnalysisTableColsItems
    },
    on: {
      "updated": _vm.updateLemonAnalysisStatus
    },
    model: {
      value: (_vm.lemonAnalysisColSettingsDialog),
      callback: function($$v) {
        _vm.lemonAnalysisColSettingsDialog = $$v
      },
      expression: "lemonAnalysisColSettingsDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f657784"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/CampaignSettingsModal.vue
// module id = 2004
// module chunks = 0